import React from "react";
import { Link } from "react-router-dom";
import BrandMark from "./BrandMark";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-[#1A2B20] bg-[#050605] mt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <BrandMark variant="knot" className="h-11 w-11" />
            <BrandMark variant="wordmark" className="h-11 w-auto max-w-[110px]" />
          </div>
          <p className="text-sm text-[#95A89C] leading-relaxed max-w-xs">
            Independent Irish-rooted art, music, and photography — handcrafted, watermarked, never stolen.
          </p>
        </div>
        <div>
          <div className="text-xs tracking-[0.3em] uppercase text-[#5C7064] mb-4">Collection</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/music" className="hover:text-[#279153]">Music</Link></li>
            <li><Link to="/photography" className="hover:text-[#279153]">Photography</Link></li>
            <li><Link to="/drawings" className="hover:text-[#279153]">Artwork</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs tracking-[0.3em] uppercase text-[#5C7064] mb-4">Studio</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/about" className="hover:text-[#279153]">About the artist</Link></li>
            <li><Link to="/contact" className="hover:text-[#279153]">Contact</Link></li>
            <li><Link to="/orders" className="hover:text-[#279153]">My orders</Link></li>
            <li>
              <a href="mailto:hello@gracreation.com" className="hover:text-[#279153]">
                hello@gracreation.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1A2B20]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#5C7064] tracking-wider">
          <div>© {new Date().getFullYear()} Grá Studio · Go raibh maith agat</div>
          <div>All works watermarked & protected</div>
        </div>
      </div>
    </footer>
  );
}
